import type { SpacingValue } from '../../../styles/spacing';

const MIN_WIDTH = 150;
const VIEWPORT_EDGE_PADDING: SpacingValue = 6;
const DEFAULT_TOOLTIP_WIDTH = 360;

/**
 * Calculates the maximum width for a tooltip to fit within the viewport.
 * Returns the default width if there is no overflow.
 */
export function getMaxTooltipWidth(tooltipElement: HTMLElement): number {
  if (typeof window === 'undefined' || !tooltipElement) {
    return DEFAULT_TOOLTIP_WIDTH;
  }
  const tooltipRect = tooltipElement.getBoundingClientRect();
  const viewportWidth = window.innerWidth;

  const centerX = tooltipRect.left + tooltipRect.width / 2;
  const spaceLeft = centerX - VIEWPORT_EDGE_PADDING;
  const spaceRight = viewportWidth - centerX - VIEWPORT_EDGE_PADDING;
  const availableWidth = 2 * Math.max(0, Math.min(spaceLeft, spaceRight));
  return Math.max(
    MIN_WIDTH,
    Math.min(DEFAULT_TOOLTIP_WIDTH, availableWidth || DEFAULT_TOOLTIP_WIDTH)
  );
}
